import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "portfolio",
  class: "max-w-1200px w-full mx-auto md:py-264px py-20 px-4 md:px-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-Roboto-Medium md:text-32px leading-10 text-2xl text-scp-black mb-8" }, " Portfolio ", -1)
const _hoisted_3 = { class: "grid-Portfolio items-center" }
const _hoisted_4 = {
  key: 0,
  class: "w-full h-full bg-scp-black3 flex justify-center items-center rounded-2xl relative"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "md:h-20 h-16 flex justify-center items-center font-Roboto-Medium text-scp-purple text-base leading-none" }, " Stay tuned... ", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { computed } from 'vue'
import PortfolioItem from './PortfolioItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Portfolio',
  setup(__props) {

const portfolioListTest = computed(() => {
  return [
    {
      href: 'https://carv.io/',
      defaultImg: 'carv.svg',
      hoverImg: 'carv_hoverd.svg',
      className: 'w-60'
    },
    {
      href: 'https://mindnetwork.xyz/',
      defaultImg: 'mind_network_normal.png',
      hoverImg: 'mind_network.png',
      className: 'w-120px'
    },
    {
      href: 'https://padolabs.org/',
      defaultImg: 'pado.svg',
      hoverImg: 'pado_hoverd.svg'
    },
    {
      href: 'https://www.revox.ai/',
      defaultImg: 'revox.svg',
      hoverImg: 'revox_hoverd.svg',
      className: 'w-120px'
    },
    {
      href: 'https://www.4everland.org/',
      defaultImg: '4everland_normal.svg',
      hoverImg: '4everland.svg'
    },
    {
      href: 'https://permaweb.news/',
      defaultImg: 'permaweb_news_normal.svg',
      hoverImg: 'permaweb_news.svg'
    },
    {
      href: 'https://www.starpower.world/#/',
      defaultImg: 'starpoweer_nomal.svg',
      hoverImg: 'starpoweer.svg'
    },
    {
      href: 'https://www.legal-dao.org/',
      defaultImg: 'legal_now_normal.svg',
      hoverImg: 'legal_now.svg'
    },
    {
      href: 'https://www.server31.io/',
      defaultImg: 's31_normal.svg',
      hoverImg: 's31.svg'
    },
    {
      href: '',
      defaultImg: '',
      hoverImg: ''
    }
  ]
})
// const portfolioList = computed(() => {
//   return [
//     [
//       {
//         href: 'https://readon.me/',
//         defaultImg: 'readon_normal.png',
//         hoverImg: 'readon.png',
//         className: 'md:h-20 md:w-120px w-24 h-16 '
//       },
//       {
//         href: 'https://mindnetwork.xyz/',
//         defaultImg: 'mind_network_normal.png',
//         hoverImg: 'mind_network.png',
//         className: 'md:h-20 md:w-120px w-24 h-16 '
//       },
//       {
//         href: 'https://www.4everland.org/',
//         defaultImg: '4everland_normal.svg',
//         hoverImg: '4everland.svg'
//       }
//     ],
//     [
//       {
//         href: 'https://permaweb.news/',
//         defaultImg: 'permaweb_news_normal.svg',
//         hoverImg: 'permaweb_news.svg'
//       },
//       {
//         href: 'https://www.starpower.world/#/',
//         defaultImg: 'starpoweer_nomal.svg',
//         hoverImg: 'starpoweer.svg'
//       },
//       {
//         href: 'https://www.legal-dao.org/',
//         defaultImg: 'legal_now_normal.svg',
//         hoverImg: 'legal_now.svg'
//       }
//     ],
//     [
//       {
//         href: 'https://www.server31.io/',
//         defaultImg: 's31_normal.svg',
//         hoverImg: 's31.svg'
//       },
//       {
//         href: 'https://www.server31.io/',
//         defaultImg: 'CARV.svg',
//         hoverImg: 'CARV.svg'
//       },
//       {
//         href: '',
//         defaultImg: '',
//         hoverImg: '',
//         stayTuned: true,
//         visible: false
//       }
//     ]
//   ]
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(portfolioListTest), (p, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "h-188px"
        }, [
          (!p.href)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (_openBlock(), _createBlock(PortfolioItem, {
                key: 1,
                href: p.href,
                "default-img": p.defaultImg,
                "class-name": p.className ? p.className : '',
                "hover-img": p.hoverImg
              }, null, 8, ["href", "default-img", "class-name", "hover-img"]))
        ]))
      }), 128))
    ])
  ]))
}
}

})